module.exports = __webpack_public_path__ + "static/img/bg8.e9634299.png";